<template>
  <footer class="footer">
    <div class="footer__container container_wide">
      <div class="footer__main">
        <button
          class="footer__button"
          @click="expanded = !expanded"
        >
          Условия акций
        </button>
        <p>
          ООО «Автомир-Трейд» Москва (Юр.адрес: 107497, город Москва, улица
          Иркутская, дом 5/6, строение 1, помещение 321) ИНН 7730569353 ОГРН
          1077761079263
        </p>
      </div>

      <div class="footer__confidentiality">
        <div class="footer__polit">
          <a
            target="_blank"
            rel="noopener"
            href="https://avtomir.ru/disclaimer/politic/"
            class="footer__btn"
          >
            Политика Конфиденциальности
          </a>
        </div>

        <div class="footer__agreement">
          <a
            target="_blank"
            rel="noopener"
            href="https://avtomir.ru/agreement/"
            class="footer__btn"
          >
            Согласие на обработку персональных данных
          </a>
        </div>
      </div>

      <transition name="fade">
        <div
          class="footer__text"
          v-if="expanded"
        >
          <p>
            * АИ-92 подходит для автомобилей JAECOO J6 и JAECOO J7, 
            требования к топливу уточняйте в руководстве по эксплуатации 
            и у официального дилера.
            <br />
            * Выгода до {{ max_benefit }} руб. Зимние шины в подарок<br />
            Зимние шины в подарок<br />
            Акция «Зимние шины в подарок» действует при покупке автомобилей
            JAECOO с {{ firstDay }} по {{ lastDay }}. преимущество достигается за счет
            соразмерного снижения стоимости нового автомобиля. Не является
            публичной офертой, определяемой положениями Статьи 437 (2)
            Гражданского кодекса Российской Федерации. Для получения подробной
            информации, пожалуйста, обращайтесь в наш салон.
            <br />Дополнительное оборудование в подарок <br />Акция
            «Дополнительное оборудование в подарок» действует при покупке
            автомобилей JAECOO с {{ firstDay }} по {{ lastDay }}. преимущество достигается
            за счет соразмерного снижения стоимости нового автомобиля. Не
            является публичной офертой, определяемой положениями Статьи 437 (2)
            Гражданского кодекса Российской Федерации. Для получения подробной
            информации, пожалуйста, обращайтесь в наш салон. Выгода до {{ max_benefit }}
            руб. <br />Максимальная выгода при покупке автомобиля JAECOO с
            учетом покупки в кредит, использования программы «Трейд ин», а также
            дополнительной выгоды, предоставляемой дилерским центром Автомир.
            Акция действует с {{ firstDay }} по {{ lastDay }}.

            <br /><br />Кредит предоставляется по условиям программы Jaecoo J8 
            Директ (Экстра): диапазон полной стоимости кредита: 0,010% до 
            12,000%, минимальная ставка от 0,010% годовых (определяется в 
            зависимости от срока кредитования и размера первоначального взноса), 
            первоначальный взнос от 20%, сумма кредита — от 300 тыс. до 5 млн 
            руб., срок кредитования – от 12 до 84 месяцев. Банк ВТБ (ПАО) не 
            занимается реализацией автомобилей и/или мотоциклов на коммерческой 
            основе, а также не осуществляет страховую деятельность. Данное 
            предложение не ограничивает возможности приобретения автомобилей в 
            кредит на других условиях. Не является офертой. Дополнительная информация 
            о наличии автомобилей, сроках и условиях программы — в дилерском центре. 
            Условия действительны на 23.01.2026 и могут быть изменены Банком. Банк 
            вправе отказать без объяснения причин. Информация по телефону Банка: 
            8-800-100-24-24 (звонок по России бесплатный). Банк ВТБ (ПАО). 
            Генеральная лицензия Банка России № 1000.Реклама 0+

            <br /><br />*Кредит предоставляется по условиям программы JAECOO J7 
            Директ Plus (Экстра): диапазон полной стоимости кредита: 0,010% до 
            14,000%, минимальная cтавка от 0,010% годовых (определяется в 
            зависимости от срока кредитования и размера первоначального взноса), 
            первоначальный взнос от 20%, сумма кредита — от 300 тыс. до 5 млн 
            руб., срок кредитования – от 12 до 84 месяцев. Банк ВТБ (ПАО) не 
            занимается реализацией автомобилей и/или мотоциклов на коммерческой 
            основе, а также не осуществляет страховую деятельность. Данное 
            предложение не ограничивает возможности приобретения автомобилей в 
            кредит на других условиях. Не является офертой. Дополнительная информация 
            о наличии автомобилей, сроках и условиях программы — в дилерском центре. 
            Условия действительны на 23.01.2026 и могут быть изменены Банком. Банк 
            вправе отказать без объяснения причин.  Информация по телефону Банка: 
            8-800-100-24-24 (звонок по России бесплатный). Банк ВТБ (ПАО). 
            Генеральная лицензия Банка России № 1000.Реклама 0+
          </p>
        </div>
      </transition>
    </div>
  </footer>
</template>

<script>
import constants from "../common/constants.js";

export default {
  name: "block-footer",
  data() {
    return {
      expanded: false,
      max_benefit: constants.max_benefit
    };
  },
  computed: {
    lastDay() {
      const today = new Date(Date.now() + 10800000);
      const lastDayCurrentMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 2,
        0
      );
      return new Date(lastDayCurrentMonth).toLocaleDateString("ru", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    firstDay() {
      const today = new Date(Date.now() + 10800000);
      const firstDayCurrentMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );
      return new Date(firstDayCurrentMonth).toLocaleDateString("ru", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";
@import "../styles/transitions.scss";

.footer {
  width: 100%;
  padding: 20px 10px;
  background: #dddddd;

  &__main {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
  }

  &__button {
    font-size: 16px;
    font-weight: bold;
    margin-right: 100px;
    border: 0;
    background: none;
    cursor: pointer;
  }

  &__confidentiality {
    margin-top: 15px;
    text-decoration: underline;
  }

  &__btn {
    cursor: pointer;
  }

  a:visited {
    color: inherit;
  }

  .ascent {
    color: #2f5496;
  }

  &__text {
    margin-top: 10px;

    sub {
      position: relative;
      bottom: 10px;
      font-size: 12px;
    }

    a {
      text-decoration: underline;
    }
  }

  &__heading {
    font-size: 1.1em;
    font-weight: 700;
    margin-top: 0.7em;

    &-name {
      font-size: 1.3em;
    }
  }
}

@media (max-width: 880px) {
  .footer {
    &__button {
      color: #fff;
    }

    &__confidentiality {
      font-size: 14px;
    }
  }
}

@media (max-width: 650px) {
  .footer {
    &__main {
      flex-direction: column-reverse;
    }

    &__button {
      font-size: 16px;
      margin: 10px 0 0;
      text-align: left;
    }
  }
}
</style>
